import _defineProperty from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { RequestStatus } from '@lib/plugin-redux-core';
import { CREATE_FILE_STORAGE_V2_USE_CASE, DELETE_FILE_V2_USE_CASE, GET_MANY_FILE_V2_USE_CASE, UPLOAD_FILE_V2_USE_CASE, VALIDATE_PUBLIC_FILE_URL_USE_CASE } from '../../../../file-storage';

/**
 * Handler for validate public file URL use case
 */
export var handleValidatePublicFileUrlUseCase = {
  name: VALIDATE_PUBLIC_FILE_URL_USE_CASE,
  executing: function executing(state) {
    return _objectSpread(_objectSpread({}, state), {}, {
      validatePublicFileUrlStatus: RequestStatus.EXECUTE
    });
  },
  success: function success(state, action) {
    return _objectSpread(_objectSpread({}, state), {}, {
      validatePublicFileUrlStatus: RequestStatus.SUCCESS,
      validatePublicFileUrlOutput: action.payload
    });
  },
  error: function error(state, action) {
    return _objectSpread(_objectSpread({}, state), {}, {
      validatePublicFileUrlStatus: RequestStatus.ERROR,
      error: action.error
    });
  },
  reset: function reset(state) {
    return _objectSpread(_objectSpread({}, state), {}, {
      validatePublicFileUrlStatus: RequestStatus.RESET,
      validatePublicFileUrlOutput: null
    });
  }
};
/**
 * Handler for upload file V2 use case
 */

export var handleUploadFileV2UseCase = {
  name: UPLOAD_FILE_V2_USE_CASE,
  executing: function executing(state) {
    return _objectSpread(_objectSpread({}, state), {}, {
      uploadFileV2Status: RequestStatus.EXECUTE
    });
  },
  success: function success(state) {
    return _objectSpread(_objectSpread({}, state), {}, {
      uploadFileV2Status: RequestStatus.SUCCESS
    });
  },
  error: function error(state, action) {
    return _objectSpread(_objectSpread({}, state), {}, {
      uploadFileV2Status: RequestStatus.ERROR,
      error: action.error
    });
  },
  reset: function reset(state) {
    return _objectSpread(_objectSpread({}, state), {}, {
      uploadFileV2Status: RequestStatus.RESET
    });
  }
};
/**
 * Handler for get many file V2 use case
 */

export var handleGetManyFileV2UseCase = {
  name: GET_MANY_FILE_V2_USE_CASE,
  executing: function executing(state) {
    return _objectSpread(_objectSpread({}, state), {}, {
      getManyFileV2Status: RequestStatus.EXECUTE
    });
  },
  success: function success(state, action) {
    var response = action.payload;
    return _objectSpread(_objectSpread({}, state), {}, {
      files: response.items,
      nextToken: response.nextToken,
      getManyFileV2Status: RequestStatus.SUCCESS
    });
  },
  error: function error(state, action) {
    return _objectSpread(_objectSpread({}, state), {}, {
      getManyFileV2Status: RequestStatus.ERROR,
      error: action.error
    });
  },
  reset: function reset(state) {
    return _objectSpread(_objectSpread({}, state), {}, {
      files: [],
      nextToken: undefined,
      getManyFileV2Status: RequestStatus.RESET
    });
  }
};
/**
 * Handler for delete file V2 use case
 */

export var handleDeleteFileV2UseCase = {
  name: DELETE_FILE_V2_USE_CASE,
  executing: function executing(state) {
    return _objectSpread(_objectSpread({}, state), {}, {
      deleteFileV2Status: RequestStatus.EXECUTE
    });
  },
  success: function success(state) {
    return _objectSpread(_objectSpread({}, state), {}, {
      deleteFileV2Status: RequestStatus.SUCCESS
    });
  },
  error: function error(state, action) {
    return _objectSpread(_objectSpread({}, state), {}, {
      deleteFileV2Status: RequestStatus.ERROR,
      error: action.error
    });
  },
  reset: function reset(state) {
    return _objectSpread(_objectSpread({}, state), {}, {
      deleteFileV2Status: RequestStatus.RESET
    });
  }
};
/**
 * Handler for create file storage V2 use case
 */

export var handleCreateFileStorageV2UseCase = {
  name: CREATE_FILE_STORAGE_V2_USE_CASE,
  executing: function executing(state) {
    return _objectSpread(_objectSpread({}, state), {}, {
      createFileStorageV2Status: RequestStatus.EXECUTE
    });
  },
  success: function success(state, action) {
    return _objectSpread(_objectSpread({}, state), {}, {
      createFileStorageV2Status: RequestStatus.SUCCESS,
      createFileStorageV2Output: action.payload
    });
  },
  error: function error(state, action) {
    return _objectSpread(_objectSpread({}, state), {}, {
      createFileStorageV2Status: RequestStatus.ERROR,
      error: action.error
    });
  },
  reset: function reset(state) {
    return _objectSpread(_objectSpread({}, state), {}, {
      createFileStorageV2Status: RequestStatus.RESET,
      createFileStorageV2Output: null
    });
  }
};
export var fileStorageHandlers = [handleValidatePublicFileUrlUseCase, handleUploadFileV2UseCase, handleGetManyFileV2UseCase, handleDeleteFileV2UseCase, handleCreateFileStorageV2UseCase];